import * as React from 'react';
import { IconRefresh } from '@tabler/icons-react';

export type Props = Omit<React.ComponentPropsWithRef<'div'>, 'children'> & {
  children: (el: HTMLDivElement) => React.ReactNode;
};

const Area = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, ...rest } = props;
  const [el, setEl] = React.useState<HTMLDivElement | null>(null);

  // Callback ref to set both local state and forward ref
  const handleRef = React.useCallback(
    (node: HTMLDivElement | null) => {
      setEl(node);
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref && 'current' in ref) {
        (ref as React.MutableRefObject<HTMLDivElement | null>).current = node;
      }
    },
    [ref]
  );

  const [key, setKey] = React.useState(0);

  return (
    <div
      ref={handleRef}
      css={{
        position: 'relative',
        border: '1px solid',
        borderRadius: '4px',
        width: '100%',
        height: '300px',
        marginBottom: '1rem',
      }}
      {...rest}
    >
      <button onClick={() => setKey((k) => k + 1)} css={{ position: 'absolute', right: 0, zIndex: 1 }}>
        <IconRefresh />
      </button>
      {el && <React.Fragment key={key}>{children(el)}</React.Fragment>}
    </div>
  );
});

export default React.memo(Area);
